// extracted by mini-css-extract-plugin
export default {"modalBody":"copyTerminals_modalBody__fr2Ar","list":"copyTerminals_list__kuY-L"};